import React, { useState, createContext, useContext } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from "@mui/material/Alert";

type ToastContextType = (msg: string, severity?: 'success' | 'error') => void;

const ToastContext = createContext<ToastContextType>(
    () => {}
);

export const useToast = () => {
  return useContext(ToastContext);
};

export const ToastProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<'success' | 'error'>('success');
  const [isError, setIsError] = useState(severity === 'error');

  const showToast = (msg:string, severity?: 'success' | 'error') => {
    setMessage(msg);
    setSeverity(severity || 'success');
    setIsError(severity === 'error');
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        autoHideDuration={isError ? null : 3000}
        onClose={handleClose}
        message={message}
      >
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};